import { IMenuContext } from '@/types';
import React from 'react';

/** Контекст для передачи функций работы с меню. */
export const MenuContext = React.createContext<IMenuContext>({
    onClose: () => {},
    show: false,
});
